import additives from 'stores/modules/additives'
import assignmentOfRights from 'stores/modules/assignment-of-rights'
import customers from 'stores/modules/customers'
import legalDocuments from 'stores/modules/legal-documents'
import periodicities from 'stores/modules/periodicities'
import sales from 'stores/modules/sales'
import proposalModels from 'stores/modules/proposal-models'
import salesContract from 'stores/modules/sales-contract'

// dashboards
import dashboardDiscounts from 'stores/modules/dashboard/dashboard-discounts'
import dashboardSaleChannels from 'stores/modules/dashboard/dashboard-sale-channels'
import dashboardSales from 'stores/modules/dashboard/dashboard-sales'
import dashboardTeamSales from 'stores/modules/dashboard/dashboard-team-sales'
import dashboardUnits from 'stores/modules/dashboard/dashboard-units'

// managementReports
import managementReportsGlobal from 'stores/modules/management-reports/management-reports-global'
import managementReportsSalesProducts from 'stores/modules/management-reports/management-reports-sales-products'
import managementReportsSalesProductsBuyingOptions from 'stores/modules/management-reports/management-reports-sales-products-buying-options'
import managementReportsSalesProductsCurrentStatus from 'stores/modules/management-reports/management-reports-sales-products-current-status'
import managementReportsSalesProductsCurrentStatusMirror from 'stores/modules/management-reports/management-reports-sales-products-current-status-mirror'
import managementReportsSalesProductsPriceTable from 'stores/modules/management-reports/management-reports-sales-products-price-table'
import managementReportsSalesProductsRevenueStream from 'stores/modules/management-reports/management-reports-sales-products-revenue-stream'
import managementReportsSalesProductsVgv from 'stores/modules/management-reports/management-reports-sales-products-vgv'
import managementReportsBlueprints from 'stores/modules/management-reports/management-reports-blueprints'
import managementReportsApprovals from 'stores/modules/management-reports/management-reports-approvals'
import managementReportsCommissions from 'stores/modules/management-reports/management-reports-commissions'
import managementReportsParcelFlow from 'stores/modules/management-reports/management-reports-parcel-flow'
import managementReportsPaymentFlow from 'stores/modules/management-reports/management-reports-payment-flow'
import managementReportsPersonalizations from 'stores/modules/management-reports/management-reports-personalizations'

// personalizations
import personalizations from 'stores/modules/personalizations/personalizations'
import personalizationsLegalDocuments from 'stores/modules/personalizations/personalizations-legal-documents'

// properties
import properties from 'stores/modules/properties/properties'
import propertiesDocuments from 'stores/modules/properties/properties-documents'
import propertiesInformations from 'stores/modules/properties/properties-informations'
import propertiesInterests from 'stores/modules/properties/properties-interests'
import propertiesMedias from 'stores/modules/properties/properties-medias'

// propertySales
import propertySales from 'stores/modules/property-sales/property-sales'
import propertySalesDocuments from 'stores/modules/property-sales/property-sales-documents'

// realEstateDevelopments
import realEstateDevelopments from 'stores/modules/real-estate-developments/real-estate-developments'
import realEstateDevelopmentsCharacteristics from 'stores/modules/real-estate-developments/real-estate-developments-characteristics'
import realEstateDevelopmentsDocuments from 'stores/modules/real-estate-developments/real-estate-developments-documents'
import realEstateDevelopmentsInterests from 'stores/modules/real-estate-developments/real-estate-developments-interests'
import realEstateDevelopmentsMedias from 'stores/modules/real-estate-developments/real-estate-developments-medias'
import realEstateDevelopmentsReservations from 'stores/modules/real-estate-developments/real-estate-developments-reservations'
import realEstateDevelopmentsUnitBlock from 'stores/modules/real-estate-developments/real-estate-developments-unit-block'
import realEstateDevelopmentsUnits from 'stores/modules/real-estate-developments/real-estate-developments-units'

// salesCompletions
import salesCompletions from 'stores/modules/sales-completions/sales-completions'
import salesCompletionsApprove from 'stores/modules/sales-completions/sales-completions-approve'
import salesCompletionsComments from 'stores/modules/sales-completions/sales-completions-comments'
import salesCompletionsCustomerDocuments from 'stores/modules/sales-completions/sales-completions-customer-documents'
import salesCompletionsCustomerFinancialSituation from 'stores/modules/sales-completions/sales-completions-customer-financial-situation'

// settings
import settingsGenerals from 'stores/modules/settings/settings-generals'
import settingsPricesTable from 'stores/modules/settings/settings-prices-table'

// signalPayments
import signalPaymentStatus from 'stores/modules/signal-payments/signal-payment-status'
import signalPayments from 'stores/modules/signal-payments/signal-payments'

// salesDocuments
import salesDocuments from 'stores/modules/sales-documents/sales-documents'
import salesDocumentsDivergentData from 'stores/modules/sales-documents/sales-documents-divergent-data'

// creditPolicies
import salesCreditPolicies from 'stores/modules/sales-credit-policies/sales-credit-policies'
import salesCreditPoliciesApprovers from 'stores/modules/sales-credit-policies/sales-credit-policies-approvers'

// myApprovals
import myApprovals from 'stores/modules/my-approvals/my-approvals'
import myApprovalsSales from 'stores/modules/my-approvals/my-approvals-sales'
import myApprovalsContracts from 'src/stores/modules/my-approvals/my-approvals-contracts'

// onlendings
import onlendings from 'stores/modules/onlendings'

import { hubStore as hub } from 'hub/pinia'

import { DefineGlobalPiniaStore } from '@bildvitta/store-adapter'
import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
  app.use(DefineGlobalPiniaStore, {
    stores: {
      additives,
      assignmentOfRights,
      customers,
      dashboardDiscounts,
      dashboardSaleChannels,
      dashboardSales,
      dashboardTeamSales,
      dashboardUnits,
      hub,
      legalDocuments,
      managementReportsGlobal,
      managementReportsSalesProducts,
      managementReportsSalesProductsBuyingOptions,
      managementReportsSalesProductsCurrentStatus,
      managementReportsSalesProductsCurrentStatusMirror,
      managementReportsSalesProductsPriceTable,
      managementReportsSalesProductsRevenueStream,
      managementReportsSalesProductsVgv,
      managementReportsBlueprints,
      managementReportsApprovals,
      managementReportsCommissions,
      managementReportsParcelFlow,
      managementReportsPaymentFlow,
      managementReportsPersonalizations,
      periodicities,
      personalizations,
      personalizationsLegalDocuments,
      properties,
      propertiesDocuments,
      propertiesInformations,
      propertiesInterests,
      propertiesMedias,
      propertySales,
      propertySalesDocuments,
      proposalModels,
      realEstateDevelopments,
      realEstateDevelopmentsCharacteristics,
      realEstateDevelopmentsDocuments,
      realEstateDevelopmentsInterests,
      realEstateDevelopmentsMedias,
      realEstateDevelopmentsReservations,
      realEstateDevelopmentsUnitBlock,
      realEstateDevelopmentsUnits,
      sales,
      salesCompletionsComments,
      salesCompletions,
      salesCompletionsApprove,
      salesCompletionsCustomerDocuments,
      salesCompletionsCustomerFinancialSituation,
      salesContract,
      settingsGenerals,
      settingsPricesTable,
      signalPaymentStatus,
      signalPayments,
      salesDocuments,
      salesDocumentsDivergentData,
      salesCreditPolicies,
      salesCreditPoliciesApprovers,
      myApprovals,
      myApprovalsSales,
      myApprovalsContracts,
      onlendings
    }
  })
})
